// Örnek servis codiagno login
import axios from '../javascript/custom-axios';
let RESOURCE_NAME = 'additional-cost';

export default {
  /**
   * Creates a additional cost.
   * @param {{ LogisticType: number, AdditionalCostType: number, CostParameter: number, Value: number, MinValue: number }} body
   * @returns {Promise<any>}
   */
  add(body) {
    return axios.post(`${RESOURCE_NAME}/add`, body);
  },

  /**
   * Get additional cost list.
   * @param {*} body
   * @returns {Promise<any>}
   */
  get(body) {
    return axios.get(`${RESOURCE_NAME}/get-all`, {
      params: body
    });
  },

  /**
   * Get additional cost by Id.
   * @param {string} additionalCostId
   * @returns {Promise<any>}
   */
  getById(additionalCostId) {
    return axios.get(`${RESOURCE_NAME}/get-id?Id=${additionalCostId}`);
  },

  /**
   * Updates a additional cost.
   * @param {{ LogisticType: number, AdditionalCostType: number, CostParameter: number, Value: number, MinValue: number }} body
   * @returns {Promise<any>}
   */
  update(body) {
    return axios.put(`${RESOURCE_NAME}/update`, body);
  },

  /**
   * Delete a additional cost.
   * @param {string} additionalCostId
   * @returns {Promise<any>}
   */
  delete(additionalCostId) {
    return axios.delete(`${RESOURCE_NAME}/delete?Id=${additionalCostId}`);
  },

  /**
   * Creates a FSC group.
   * @param {{ GroupName: string, FscRate: number, PriceListIds: string[] }} body
   * @returns {Promise<any>}
   */
  createFscGroup(body) {
    return axios.post(`${RESOURCE_NAME}/create-fsc-group`, body, {timeout: 0});
  },

  /**
   * Updates a FSC group.
   * @param {{ Id: string, GroupName: string, FscRate: number, PriceListIds: string[] }} body
   * @returns {Promise<any>}
   */
  updateFscGroup(body) {
    return axios.put(`${RESOURCE_NAME}/update-fsc-group`, body, {timeout: 0});
  },

  /**
   * Deletes a FSC group by ID.
   * @param {string} id
   * @returns {Promise<any>}
   */
  deleteFscGroup(id) {
    return axios.delete(`${RESOURCE_NAME}/delete-fsc-group?Id=${id}`, {timeout: 0});
  },

  /**
   * Fetches FSC groups with pagination.
   * @param {{ page: number, pageSize: number }} params
   * @returns {Promise<any>}
   */
  getFscGroups(params) {
    return axios.get(`${RESOURCE_NAME}/get-fsc-group`, { params });
  },

  /**
   * Fetches FSC price lists by FSC group ID.
   * @param {number|null} FscGroupId
   * @param {number} IntegrationLogistic
   * @returns {Promise<any>}
   */
  getFscPriceLists(FscGroupId, IntegrationLogistic) {
    return axios.get(`${RESOURCE_NAME}/get-fsc-price-lists`, {
      params: { FscGroupId, IntegrationLogistic },
    });
  },

  /**
   * Fetches cost categories.
   * @returns {Promise<any>}
   */
  getCostCategories() {
    return axios.get(`${RESOURCE_NAME}/get-additional-cost-categories`);
  },

  /**
   * Adds a new cost category.
   * @returns {Promise<any>}
   */
  addNewCostCategory(body) {
    return axios.post(`${RESOURCE_NAME}/add-additional-cost-category`, body);
  },
};
